module.exports = __webpack_public_path__ + "static/media/ic_remove_black.d43c0e9b.svg";